import type { Country, Language } from '@application/types';

export interface SeoControllerData {
  keywords?: string;
  title?: string;
  description?: string;
  thumbnail?: string;
  noIndex?: boolean;
  localeLinks?: Partial<Record<Country, Partial<Record<Language, string | undefined>> | undefined>>;
  canonical?: string;
}

export interface SeoControllerProps extends SeoControllerData {}
